import {
  BufferTrackerReact as BufferTracker,
  Client,
  Product,
} from '@buffer-mono/tracking-plan'

import { useCommonTrackingProperties } from '~publish/hooks/useCommonTrackingProperties'

type TrackTemplateFiltered = {
  cta: CTA
  filterType: 'category' | 'madeFor' | 'format' | 'goal' | 'campaign'
  filterValue: string
}

type UseTemplateTrackingResult = {
  trackTemplateFiltered: (properties: TrackTemplateFiltered) => void
}

export const useTemplateTracking = (): UseTemplateTrackingResult => {
  const commonTrackingProperties = useCommonTrackingProperties()

  const trackTemplateFiltered = ({
    cta,
    filterType,
    filterValue,
  }: TrackTemplateFiltered): void => {
    BufferTracker.templateFilterClicked({
      clientName: Client.PublishWeb,
      product: Product.Publish,
      filterType,
      filterValue,
      cta,
      ...commonTrackingProperties,
    })
  }

  return {
    trackTemplateFiltered,
  }
}
